<template>
  <article>
    <div class="article-left">
      <h3><a :href="hotArticleLeft.url">{{ hotArticleLeft.stitle }}</a></h3>
      <ul>
        <li v-for="(item, index) in hotArticleLeftList" :key="index">
          <a :href="item.url" :title="item.title">{{ item.title }}</a>
        </li>
      </ul>
    </div>
    <div class="article-right">
      <h3><a :href="hotArticleRight.url">{{ hotArticleRight.stitle }}</a></h3>
      <ul>
        <li v-for="(item, index) in hotArticleRightList" :key="index">
          <a :href="item.url" :title="item.title">{{ item.title }}</a>
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
import { getArticle } from 'js/getArticle.js'
export default {
  name: 'Hotarticle',
  data () {
    return {
      hotArticleLeft: {},
      hotArticleRight: {},
      hotArticleLeftList: [],
      hotArticleRightList: []
    }
  },
  created () {
    this.getHotArticle()
  },
  methods: {
    getHotArticle () {
      getArticle('1161,1162,1163', 1, '_WWW').then(response => {
        this.hotArticleLeft = response[0]
      })
      getArticle('1440,4910,5181,1507,1509,1510', 4, '_WWW').then(response => {
        this.hotArticleLeftList = response
      })
      getArticle('1177,1178,1179', 1, '_WWW').then(response => {
        this.hotArticleRight = response[0]
      })
      getArticle('1533,8698,1172,1538,1539,1540', 4, '_WWW').then(response => {
        this.hotArticleRightList = response
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
article
  width: 750px
  height: 138px
  margin: 0 8px
  font-size: 14px
  float: left
  display: flex
  .article-left
    flex: 1
    display: flex
    flex-direction: column
    h3
      flex: 1
      a
        height: 40px
        line-height: 40px
        overflow: hidden
        line-height: 40px
        color: $themeColor
        font-size: 18px
        font-weight: 400
        &:hover
          text-decoration: underline
    ul
      flex: 3
      flex-direction: column
      display: flex
      li
        flex: 1
        background: url(http://images.xdf.cn/school/middleschool/static/images/dian.jpg) no-repeat 4px 12px;
        padding-left: 14px
        align-items: center
        display: flex
        a
          color: #7a7a7a
          overflow: hidden
          white-space: nowrap
          text-overflow: ellipsis
          width: 350px
          &:hover
            color: $themeColor
            text-decoration: underline
  .article-right
    flex: 1
    display: flex
    flex-direction: column
    h3
      flex: 1
      a
        height: 40px
        line-height: 40px
        overflow: hidden
        color: $themeColor
        font-size: 18px
        font-weight: 400
        &:hover
          text-decoration: underline
    ul
      flex: 3
      flex-direction: column
      display: flex
      li
        flex: 1
        background: url(http://images.xdf.cn/school/middleschool/static/images/dian.jpg) no-repeat 4px 12px;
        padding-left: 14px
        align-items: center
        display: flex
        a
          white-space: nowrap
          text-overflow: ellipsis
          width: 350px
          color: #7a7a7a
          overflow: hidden
          &:hover
            color: $themeColor
            text-decoration: underline
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Hotarticle.vue